import { useSectionScrollspy } from '../../settings/in-page-sections'
import { useLingui } from '@lingui/react/macro'
import { GUIDE_SECTIONS, type GuideSectionId } from 'shared/guide-sections'

// The guide's sections, shared by the tutorial (which renders them) and the Settings sidebar (which lists them and
// follows the reader through them). A leaf module: the account layout imports it, and must not pull the tutorial in.

export { GUIDE_SECTIONS, type GuideSectionId }

export function useGuideTitles(): Record<GuideSectionId, string> {
  const { t } = useLingui()
  return {
    authentication: t`Connect with your API key`,
    companies: t`Create a company`,
    candidates: t`Create the candidates`,
    test: t`Send the psychographic test`,
    jobs: t`Create and describe a job position`,
    matching: t`Add candidates and rank them`,
    reports: t`Show the full reports`,
    sdk: t`Embed our screens with the SDK`,
    updates: t`Update and delete`,
    errors: t`Handle errors`,
  }
}

/** The guide's section the reader is in (useSectionScrollspy), heard only on the guide. */
export function useGuideScrollspy(enabled: boolean): GuideSectionId {
  return useSectionScrollspy(GUIDE_SECTIONS, enabled) as GuideSectionId
}
